module.exports = __webpack_public_path__ + "static/img/img4x.b3b24c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/img4x.png
// module id = ySKE
// module chunks = 1